import { Zone } from '@/__generated__/graphql';
import { Cuboid, CuboidVariants, Number3 } from '@abyss/3d-viewer';
import { memo } from 'react';

type Props = { zone: Zone };
export const ZoneBoundaries = memo(({ zone }: Props) => {
  const { id, name, box } = zone;

  const position: Number3 = [
    (box.min.x + box.max.x) * 0.5,
    (box.min.y + box.max.y) * 0.5,
    (box.min.z + box.max.z) * 0.5,
  ];

  const rotation: Number3 = [0, 0, 0];

  const scale: Number3 = [box.max.x - box.min.x, box.max.y - box.min.y, box.max.z - box.min.z];

  return (
    <Cuboid
      name={`Zone ${name}`}
      id={id}
      key={id}
      position={position}
      rotation={rotation}
      scale={scale}
      style={{
        lineColor: 0xffffff,
        lineOpacity: 0.5,
        lineWidth: 1,
        fillColor: 0xffffff,
        fillOpacity: 0.02,
        variant: CuboidVariants.LinesAndTransparentMesh,
      }}
      enableClippingByVisibilityBox={false}
    />
  );
});
